import React from 'react';
import { FormattedMessage } from 'react-intl';
import { learnMore } from '../pdpMessages';
import get from 'lodash.get';

const WHITE_GLOVE_SERVICE_TYPE = 'WHITE_GLOVE';
const isWhiteGloveServiceType = quote =>
    get(quote, 'serviceMethod.serviceType') === WHITE_GLOVE_SERVICE_TYPE;

export const viewAll = (
    <FormattedMessage
        id="pdpMobileShippingHelpers.view_all_cta"
        defaultMessage="View All Shipping Quotes"
    />
);

export const viewQuotes = (
    <FormattedMessage id="pdpShipping.view_quotes" defaultMessage="View all shipping quotes" />
);

export const requestQuotes = (
    <FormattedMessage id="pdpShipping.request_quotes" defaultMessage="Request a shipping quote" />
);

export const viewAndRequestQuotes = (
    <FormattedMessage
        id="pdpShipping.view_and_request_quotes"
        defaultMessage="View and request shipping quotes"
    />
);

export const shippingModal = {
    modalTitle: <FormattedMessage id="pdpShippingModal.modal_title" defaultMessage="Shipping" />,
    shipTo: <FormattedMessage id="pdpShippingModal.ship_to" defaultMessage="Ship to" />,
    method: <FormattedMessage id="pdpShippingModal.method" defaultMessage="Method" />,
    time: <FormattedMessage id="pdpShippingModal.time" defaultMessage="Shipping time" />,
    price: <FormattedMessage id="pdpShippingModal.price" defaultMessage="Price" />,
    linkCta: learnMore,
    shipsFrom: function shipsFrom(address) {
        return (
            <FormattedMessage
                id="pdpShippingModal.ships_from"
                defaultMessage="ships from {address}"
                values={{ address }}
            />
        );
    },
    serviceMethod: function serviceMethod(quote) {
        const buyerServiceMethodDisplay = isWhiteGloveServiceType(quote)
            ? `${quote.buyerServiceMethodDisplay} (Full Service)`
            : quote.buyerServiceMethodDisplay;
        const is1stdibsBilledQuote = quote.is1stdibsBilledQuote && !isWhiteGloveServiceType(quote);
        return (
            <FormattedMessage
                id="pdpShippingModal.service_method"
                defaultMessage={`{is1stdibsBilledQuote, select,
                true {1stdibs {buyerServiceMethodDisplay}}
                other {{buyerServiceMethodDisplay}}
            }`}
                values={{ is1stdibsBilledQuote, buyerServiceMethodDisplay }}
            />
        );
    },
    serviceDescription: function serviceDescription(quote) {
        return (
            <FormattedMessage
                id="pdpShippingModal.service_description"
                defaultMessage={`{serviceType, select,
                PARCEL {{serviceMethodType, select,
                    MESSENGER {Hand-delivered via a local messenger service at a time that is convenient for you to sign for a delivery.}
                    other {Carefully packaged and delivered via a parcel delivery service such as UPS or FedEx.}
                }}
                FREIGHT {Delivered to front door of your house or building and does not include unpacking, inspection, assembly, or installation.}
                other {Delivered to room of choice and includes unpacking, inspection, and minor assembly at your convenience.}
            } Facilitated by {is1stdibsBilledQuote, select,
                true {1stdibs}
                other {seller}
            }.`}
                values={{
                    serviceType: quote.serviceMethod.serviceType,
                    serviceMethodType: quote.serviceMethod.serviceMethodType,
                    is1stdibsBilledQuote: quote.is1stdibsBilledQuote,
                }}
            />
        );
    },
    requestShippingQuote: (
        <FormattedMessage
            id="pdpShippingModal.request_shipping_modal"
            defaultMessage="Request a Shipping Quote"
        />
    ),
    disclaimer: (
        <FormattedMessage
            id="pdpShippingModal.disclaimer"
            defaultMessage="To obtain a shipping quote, proceed to checkout and complete your purchase. You will not be charged at this time. Within 48 hours, you will receive a shipping quote via email for your approval. If you do not approve the quote, you will not be charged and your order will be cancelled."
        />
    ),
    legal: (
        <FormattedMessage
            id="pdpShippingModal.legal"
            defaultMessage="Customs duties and taxes may apply to international purchases. {linkCta}"
            values={{
                linkCta: (
                    <a
                        href="https://support.1stdibs.com/s/article/Customs-Duties-and-Taxes-for-International-Shipments"
                        target="_blank"
                    >
                        {learnMore}
                    </a>
                ),
            }}
        />
    ),
    preDisclaimerStandard: (
        <FormattedMessage
            id="pdpShippingModal.pre_disclaimer_standard"
            defaultMessage="Shipping somewhere else?"
        />
    ),
    preDisclaimerRequestShippingQuote: (
        <FormattedMessage
            id="pdpShippingModal.pre_disclaimer_request_shipping_quote"
            defaultMessage="Need different shipping arrangements?"
        />
    ),
};
